import { render, staticRenderFns } from "./Capabilities.vue?vue&type=template&id=17b0a51e&scoped=true&"
import script from "./Capabilities.vue?vue&type=script&lang=js&"
export * from "./Capabilities.vue?vue&type=script&lang=js&"
import style0 from "./Capabilities.vue?vue&type=style&index=0&id=17b0a51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b0a51e",
  null
  
)

export default component.exports